<template>
  <delete-box
    class="pad-top"
    text="Are you sure you want to delete this profile?"
    loaderText="Deleting Profile"
    :showLoader="showLoader">
      <a v-on:click="submit" class="add button level-item">
        <i class="far fa-save"></i>
        Delete Profile
      </a>
  </delete-box>
</template>

<script>
import DeleteBox from '@/components/DeleteBox.vue';

export default {
  name: 'ProfileDelete',
  components: { DeleteBox },
  props: {
    profile: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showLoader: false,
    };
  },
  methods: {
    async submit() {
      this.showLoader = true;
      const profile = await this.$store.dispatch('primary/deleteProfile', { id: this.profile.id });
      this.showLoader = false;
      if (profile) {
        this.$router.push({ name: 'profiles.index' });
      }
    },
  },
};
</script>

<style lang="scss" scoped>

.pad-top {
  margin-top: $content-padding;
}
</style>
